export default __webpack_public_path__ + "static/media/manasi.4dc910f7.jpg";